module.exports = __webpack_public_path__ + "static/media/img1.f8a412fe.jpg";